import React from 'react';

function Home() {
  return (
    <main>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              Fresh Food,<br />
              <span>Delivered Fast</span>
            </h1>
            <p>
              Order your favorite dishes from Little Avalon for delivery or pickup. 
              Download our app for the best experience, exclusive deals, and rewards.
            </p>
            <div className="hero-buttons" id="download">
              <a href="#" className="btn-primary coming-soon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                App Store
                <span className="coming-soon-badge">Coming Soon</span>
              </a>
              <a href="#" className="btn-primary coming-soon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.18 23.04c-.63-.37-.97-.92-.97-1.56V2.52c0-.63.34-1.19.97-1.56l9.8 11.04-9.8 11.04zm10.77-10.17l2.37-2.67 4.26 2.43c.76.43.97 1.07.97 1.37s-.21.94-.97 1.37l-4.26 2.43-2.37-2.67-.01-.01 .01-.25zm-1.08-1.22L4.68 2.21l9.27 5.28-1.08 4.16zm0 2.7l1.08 4.16-9.27 5.28 8.19-9.44z"/>
                </svg>
                Google Play
                <span className="coming-soon-badge">Coming Soon</span>
              </a>
            </div>
          </div>
          <div className="hero-image">
            <div className="phone-mockup">
              <div className="phone-screen">
                <h2>Little Avalon</h2>
                <p>Order delicious food<br />right from your phone</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2>Why Choose Our App?</h2>
        <p>Experience the easiest way to order your favorite food</p>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🚀</div>
            <h3>Fast Ordering</h3>
            <p>Order in just a few taps. Save your favorites and reorder with one click.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎁</div>
            <h3>Earn Rewards</h3>
            <p>Get points on every order. Redeem them for free food and exclusive perks.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🚗</div>
            <h3>Delivery & Pickup</h3>
            <p>Choose delivery to your door or pickup when it's ready. You're in control.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Real-Time Tracking</h3>
            <p>Track your order from kitchen to doorstep with live updates.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💳</div>
            <h3>Easy Payment</h3>
            <p>Pay securely with Apple Pay, Google Pay, or save your card for faster checkout.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔔</div>
            <h3>Order Updates</h3>
            <p>Get notified when your order is confirmed, being prepared, and ready.</p>
          </div>
        </div>
      </section>

      {/* Download CTA Section */}
      <section className="download" id="download-section">
        <h2>Get the App Today</h2>
        <p>Download the Little Avalon app and start enjoying fresh, delicious food delivered right to your door.</p>
        <div className="download-buttons">
          <a href="#" className="btn-primary coming-soon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
            App Store - Coming Soon
          </a>
          <a href="#" className="btn-primary coming-soon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.18 23.04c-.63-.37-.97-.92-.97-1.56V2.52c0-.63.34-1.19.97-1.56l9.8 11.04-9.8 11.04zm10.77-10.17l2.37-2.67 4.26 2.43c.76.43.97 1.07.97 1.37s-.21.94-.97 1.37l-4.26 2.43-2.37-2.67-.01-.01 .01-.25zm-1.08-1.22L4.68 2.21l9.27 5.28-1.08 4.16zm0 2.7l1.08 4.16-9.27 5.28 8.19-9.44z"/>
            </svg>
            Google Play - Coming Soon
          </a>
        </div>
      </section>

      {/* Location Section */}
      <section className="location">
        <div className="location-content">
          <div className="location-info">
            <h2>Visit Us</h2>
            <p>Can't wait for delivery? Stop by our location for dine-in or quick pickup.</p>
            <div className="address">
              <div className="address-icon">📍</div>
              <div>
                <strong>Little Avalon</strong><br />
                9410 W Sahara Ave Ste 130<br />
                Las Vegas, NV 89117<br /><br />
                <strong>Phone:</strong> (702) 462-9252
              </div>
            </div>
          </div>
          <div className="location-map">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3222.8!2d-115.305!3d36.144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDA4JzM4LjQiTiAxMTXCsDE4JzE4LjAiVw!5e0!3m2!1sen!2sus!4v1600000000000!5m2!1sen!2sus"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Little Avalon Location"
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
